import { WarningIcon } from "@/assets/icons";
import { MESSAGE } from "@/constants/message";
import { cn } from "@/lib/utils";

interface WeightAutoAdjustedAlertProps {
  /** Advanced normalization mode renders the red (generate-blocking) variant;
   * simple mode renders the orange review reminder. */
  isAdvancedMode: boolean;
  className?: string;
  "data-testid"?: string;
}

const WeightAutoAdjustedAlert = ({
  isAdvancedMode,
  className,
  ...rest
}: WeightAutoAdjustedAlertProps) => {
  return (
    <div
      role="alert"
      className={cn(
        "flex items-start gap-2 rounded-lg border p-2",
        isAdvancedMode
          ? "border-cinnabar bg-red-50"
          : "border-tangerine bg-orange-50",
        className
      )}
      {...rest}
    >
      <WarningIcon
        className={cn(
          "mt-0.5 size-4.5 shrink-0",
          isAdvancedMode ? "fill-cinnabar" : "fill-tangerine"
        )}
        data-testid="weight-auto-adjusted-icon"
      />
      <span className={cn("text-[10px] leading-4 text-txtHeading")}>
        {isAdvancedMode
          ? MESSAGE.DATA_WEIGHT_AUTO_ADJUSTED.ADVANCED
          : MESSAGE.DATA_WEIGHT_AUTO_ADJUSTED.SIMPLE}
      </span>
    </div>
  );
};

export default WeightAutoAdjustedAlert;
